(() => {
  const HEADER_LINK =
    ".collection-header:not(.product-type-header) .collection-slide-link, " +
    ".collection-header:not(.product-type-header) .collection-item__title";

  const PRODUCT_TYPE_LINK =
    ".product-type-header .product-type-slide-link, " +
    ".product-type-header .product-type-item__title";

  const GRID_SELECTOR =
    '[id^="shopify-section-"][id*="__product-grid"]';

  const cache = new Map();
  let controller = null;

  const getCollectionDocument = async (url, signal) => {
    const absoluteUrl = new URL(
      url,
      window.location.origin
    ).href;

    if (cache.has(absoluteUrl)) {
      return cache.get(absoluteUrl);
    }

    const promise = fetch(absoluteUrl, {
      signal,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Collection request failed");
        }

        return response.text();
      })
      .then((html) => {
        return new DOMParser().parseFromString(
          html,
          "text/html"
        );
      })
      .catch((error) => {
        cache.delete(absoluteUrl);
        throw error;
      });

    cache.set(absoluteUrl, promise);

    return promise;
  };

  const prefetchCollection = (url) => {
    getCollectionDocument(url).catch(() => {});
  };

  /*
   * EXPANSIONES
   *
   * Si ya existe un filtro por tipo de producto,
   * lo conserva al cambiar de expansión.
   */
  const getExpansionUrl = (link) => {
    const targetUrl = new URL(
      link.href,
      window.location.origin
    );

    const currentUrl = new URL(
      window.location.href
    );

    const currentProductType =
      currentUrl.searchParams.get(
        "filter.p.product_type"
      );

    targetUrl.searchParams.delete("page");

    if (currentProductType) {
      targetUrl.searchParams.set(
        "filter.p.product_type",
        currentProductType
      );
    }

    return targetUrl.href;
  };

  /*
   * TIPOS DE PRODUCTO
   *
   * Conserva la expansión actual y solamente
   * cambia filter.p.product_type.
   */
  const getProductTypeUrl = (link) => {
    const targetUrl = new URL(
      window.location.href
    );

    const item = link.closest(
      ".collection-list__item[data-product-type]"
    );

    const productType =
      item?.dataset.productType || "";

    targetUrl.searchParams.delete("page");

    if (productType) {
      targetUrl.searchParams.set(
        "filter.p.product_type",
        productType
      );
    } else {
      targetUrl.searchParams.delete(
        "filter.p.product_type"
      );
    }

    return targetUrl.href;
  };

  /*
   * ARO AZUL:
   * EXPANSIÓN ACTIVA
   */
  const setCurrentCollection = (url) => {
    const targetPath = new URL(
      url,
      window.location.origin
    ).pathname;

    document
      .querySelectorAll(
        ".collection-header:not(.product-type-header) " +
        ".collection-list__item"
      )
      .forEach((item) => {
        const link = item.querySelector(
          ".collection-slide-link"
        );

        if (!link) return;

        const linkPath = new URL(
          link.href,
          window.location.origin
        ).pathname;

        item.classList.toggle(
          "current",
          linkPath === targetPath
        );
      });
  };

  /*
   * ARO AZUL:
   * TIPO DE PRODUCTO ACTIVO
   */
  const setCurrentProductType = (url) => {
    const selectedType =
      new URL(
        url,
        window.location.origin
      ).searchParams.get(
        "filter.p.product_type"
      ) || "";

    document
      .querySelectorAll(
        ".product-type-header " +
        ".collection-list__item[data-product-type]"
      )
      .forEach((item) => {
        item.classList.toggle(
          "current",
          item.dataset.productType === selectedType
        );
      });
  };

  /*
   * CARGA AJAX DEL GRID
   */
  const loadCollection = async (
    url,
    pushState = true
  ) => {
    if (controller) {
      controller.abort();
    }

    controller = new AbortController();

    try {
      const doc = await getCollectionDocument(
        url,
        controller.signal
      );

      const currentGrid =
        document.querySelector(GRID_SELECTOR);

      const newGrid =
        doc.querySelector(GRID_SELECTOR);

      if (!currentGrid || !newGrid) {
        window.location.href = url;
        return;
      }

      currentGrid.replaceWith(
        newGrid.cloneNode(true)
      );

      setCurrentCollection(url);
      setCurrentProductType(url);

      if (pushState) {
        history.pushState({}, "", url);
      }

      document.title = doc.title;

      document.dispatchEvent(
        new CustomEvent(
          "topcards:collection-updated",
          {
            detail: { url },
          }
        )
      );
    } catch (error) {
      if (error.name !== "AbortError") {
        window.location.href = url;
      }
    }
  };

  /*
   * PREFETCH DE EXPANSIONES
   */
  document.addEventListener(
    "pointerenter",
    (event) => {
      const link =
        event.target.closest?.(HEADER_LINK);

      if (!link) return;

      prefetchCollection(
        getExpansionUrl(link)
      );
    },
    true
  );

  document.addEventListener(
    "focusin",
    (event) => {
      const link =
        event.target.closest?.(HEADER_LINK);

      if (!link) return;

      prefetchCollection(
        getExpansionUrl(link)
      );
    }
  );

  document.addEventListener(
    "touchstart",
    (event) => {
      const link =
        event.target.closest?.(HEADER_LINK);

      if (!link) return;

      prefetchCollection(
        getExpansionUrl(link)
      );
    },
    {
      passive: true,
      capture: true,
    }
  );

  /*
   * PREFETCH DE TIPOS DE PRODUCTO
   */
  document.addEventListener(
    "pointerenter",
    (event) => {
      const link =
        event.target.closest?.(PRODUCT_TYPE_LINK);

      if (!link) return;

      prefetchCollection(
        getProductTypeUrl(link)
      );
    },
    true
  );

  document.addEventListener(
    "focusin",
    (event) => {
      const link =
        event.target.closest?.(PRODUCT_TYPE_LINK);

      if (!link) return;

      prefetchCollection(
        getProductTypeUrl(link)
      );
    }
  );

  document.addEventListener(
    "touchstart",
    (event) => {
      const link =
        event.target.closest?.(PRODUCT_TYPE_LINK);

      if (!link) return;

      prefetchCollection(
        getProductTypeUrl(link)
      );
    },
    {
      passive: true,
      capture: true,
    }
  );

  /*
   * CLICK EN EXPANSIÓN
   */
  document.addEventListener(
    "click",
    (event) => {
      const link =
        event.target.closest(HEADER_LINK);

      if (!link) return;

      if (
        event.ctrlKey ||
        event.metaKey ||
        event.shiftKey ||
        event.altKey ||
        event.button !== 0
      ) {
        return;
      }

      event.preventDefault();

      loadCollection(
        getExpansionUrl(link)
      );
    }
  );

  /*
   * CLICK EN TIPO DE PRODUCTO
   */
  document.addEventListener(
    "click",
    (event) => {
      const link =
        event.target.closest(PRODUCT_TYPE_LINK);

      if (!link) return;

      if (
        event.ctrlKey ||
        event.metaKey ||
        event.shiftKey ||
        event.altKey ||
        event.button !== 0
      ) {
        return;
      }

      event.preventDefault();

      loadCollection(
        getProductTypeUrl(link)
      );
    }
  );

  /*
    * LIMPIAR TODOS LOS FILTROS
    *
    * Regresa a:
    * - Todas las Expansiones
    * - Todos los Productos
    */
  document.addEventListener(
    "click",
    (event) => {
      const link = event.target.closest(
        ".active-facets__button-remove, .remove-all-link"
      );

      if (!link) return;

      const allExpansionsLink =
        document.querySelector(
          ".collection-header:not(.product-type-header) " +
          ".collection-list__item.all-products " +
          ".collection-slide-link"
        );

      if (!allExpansionsLink) return;

      event.preventDefault();
      event.stopPropagation();

      const targetUrl = new URL(
        allExpansionsLink.href,
        window.location.origin
      );

      /*
        * Eliminamos cualquier filtro,
        * paginación u ordenamiento de la URL.
        */
      targetUrl.search = "";

      loadCollection(targetUrl.href);
    },
    true
  );

  /*
   * ATRÁS / ADELANTE DEL NAVEGADOR
   */
  window.addEventListener(
    "popstate",
    () => {
      loadCollection(
        window.location.href,
        false
      );
    }
  );

  /*
   * ESTADO INICIAL DE LOS DOS HEADERS
   */
  setCurrentCollection(
    window.location.href
  );

  setCurrentProductType(
    window.location.href
  );
})();